import { useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { DynamicRestQueryOptions, makeQueryString } from "lib/dynamicRest";
import { ORDERBOOK_URL } from "services/constants";
import { ExchangeNotification } from "services/exchangeNotifications/types";

export const getExchangeNotifications = async (
  queryOptions: DynamicRestQueryOptions,
) => {
  const queryString = makeQueryString(queryOptions);
  const notifications = await makeSimpleGetRequest<ExchangeNotification[]>(
    `${ORDERBOOK_URL}/exchange-notifications/?${queryString}`,
  );
  return notifications?.[0] || null;
};

export const useExchangeNotifications = (
  queryOptions: DynamicRestQueryOptions = {},
  enabled: boolean, // authentication is required to request from the backend
) => {
  return useQuery<ExchangeNotification | null>(
    ["exchangeNotifications", queryOptions],
    () => getExchangeNotifications(queryOptions),
    { enabled },
  );
};
